import React, {useCallback, useEffect} from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import "react-toastify/dist/ReactToastify.css";
import Button from "react-bootstrap/Button";
import RightModal from "./modalForm";

// hooks
import { useRedux, useHistory, useSearchInput } from "../../../hooks";

import {
    editDataSaleCurrency,
    getSaleCurrencies,
    onRemoveSaleCurrency,
    removeSaleCurrencyModalHide,
    removeSaleCurrencyModalShow,
    showRightModalSaleCurrency
} from "../../../redux/actions";

import TableList from "../../../components/TableList";
import SaleCurrencyColumns from "./tableColumns";
import {CurrencyType} from "../../../redux/Sale/Currency/types";
import {EntityActionsHandlersType} from "../../../redux/types";
import RemoveModal from "../../../components/RemoveForm";

import '../../../i18/config';
import {useTranslation} from "react-i18next";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import Loader from "../../../components/Loader";
import MainListFilter from "../../../components/MainListFilter";

const SaleCurrencyIndex = () => {
    const { dispatch, useAppSelector } = useRedux();

    const { t } = useTranslation(['common']);

    const componentType = 'saleCurrencyTable';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getSaleCurrencies,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const {
        saleCurrency,
        isFetched
    } = useAppSelector(state => ({
        saleCurrency: state.SaleCurrency,
        isFetched: state.SaleCurrency.isFetched
    }));

    const openRightModal = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(editDataSaleCurrency({data:event, modalEditTitle: 'changeCurrency'}));
        } else {
            dispatch(showRightModalSaleCurrency({data:[], modalEditTitle: 'newCurrency'}));
        }
    },[dispatch]);

    const onEntityRemoveModalShow = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(removeSaleCurrencyModalShow({data:event, modalEditTitle: 'deleteCurrency'}));
        }
    },[dispatch]);

    const onEntityRemoveModalHide = useCallback(() => dispatch(removeSaleCurrencyModalHide()),[dispatch]);

    const onEntityRemove = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(onRemoveSaleCurrency({data:event, modalEditTitle: 'deleteCurrency'}));
        }
    },[dispatch]);

    useEffect(() => {
        if(saleCurrency.isNeedReload){
            loadItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadItems, saleCurrency.isNeedReload]);

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onEdit: openRightModal,
        onRemove: onEntityRemoveModalShow
    }

    const onTableRowClick = useCallback((item:CurrencyType) => {
        if (item.actions && item.actions.canEdit){
            openRightModal(item);
        }
    },[openRightModal]);

    const columns = SaleCurrencyColumns(EntityActionsHandlers);

    return (
        <>
            <BreadCrumb title={t('menu:currencies')} pageTitle={t('menu:main')} />
                <Row className="g-4 mb-3">
                    <div className="col-sm-auto">
                        <div>
                            <Button variant="secondary" onClick={openRightModal} className="btn btn-success">
                                <i className="ri-add-line align-bottom me-1"/> {t('common:addNew')}
                            </Button>
                        </div>
                    </div>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="border-bottom-0">
                                <h5 className="card-title mb-0">{t('currency:currencies')}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                                <MainListFilter
                                    onClick={handleSearchClick}
                                    value={searchPhrase}
                                    onChange={onSearchInput}
                                />
                            </CardBody>
                            <CardBody>
                                {isFetched ?
                                    <TableList
                                    columns={columns}
                                    data={saleCurrency.items}
                                    onRowClick={onTableRowClick}
                                    key={componentType}
                                    historyHash = {historyHash}
                                    paginationTotalRows={saleCurrency?.meta?.totalCount || 0}
                                    paginationServer={true}
                                    isShowChangePageSize={true}
                                    />
                                    :
                                    <Loader/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <RightModal/>
                <RemoveModal
                    onRemove={onEntityRemove}
                    handleClose={onEntityRemoveModalHide}
                    removeItem={saleCurrency.selectedItem}
                    isOpen={saleCurrency.removeModalShow}
                    modalTitle={saleCurrency.modalEditTitle}/>
        </>
    );
};

export default SaleCurrencyIndex;


